<template>
  <details
    v-if="collapsible"
    class="group border-b border-default pb-4 last:border-b-0"
    :open="defaultOpen"
  >
    <summary
      class="flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-medium text-highlighted [&::-webkit-details-marker]:hidden"
    >
      <span>{{ label }}</span>
      <UIcon
        name="i-heroicons-chevron-down"
        class="size-4 shrink-0 text-muted transition-transform group-open:rotate-180"
      />
    </summary>
    <div class="mt-3 space-y-3">
      <slot />
    </div>
  </details>

  <UFormField v-else :label="label">
    <slot />
  </UFormField>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  label: string
  collapsible?: boolean
  defaultOpen?: boolean
}>(), {
  collapsible: false,
  defaultOpen: true,
})
</script>
